import { Button, createMuiTheme, makeStyles, TextField, Typography } from "@material-ui/core"
import { ChevronRight } from "@material-ui/icons"
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import STATIC_TEXT from '../../content/common.json';
import Spacing from "../portico/spacing/spacing";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCodatIntegration } from "../../stores/async/async-actions";
import { useEntityState } from "../../stores/entity/entity.hooks";
import { setCodatState } from "../../stores/ui/ui-action";
import { useCodatState } from "../../stores/ui/ui.hooks";
import WARNING_URL from '../../assets/warning.svg';
import useCustomCodatButtonStyles from './custom-codat-button.styles';
import { FCB_PRIVACY_STATEMENT } from "../../utils/urls";

interface CodatButtonProps {
  handleOpenSyncModal: Function,
  setValue: Function,
  register: Function,
  unregister: Function,
  name: string,
  value: string
  source?: string
}
export const CodatButton: React.FC<CodatButtonProps> = ({ setValue, register, unregister, value, name, source, ...props }) => {
  const styles = useCustomCodatButtonStyles();
  const currentStepperIndex = useSelector((state: any) => state.ui.currentStepperIndex, () => true);
  const codatState = useCodatState();
  const [connectedPlatform, setConnectedPlatform] = useState<string>();
  const dispatch = useDispatch();
  const { codatIntegrationLoadInProgress, codatIntegration } = useEntityState();

  useEffect(() => {
    if ((codatState.integration && codatState.statusCode === '200') || value) {
      const companyName = codatState.companyName ? ' (' + codatState.companyName + ')' : '';
      const platform = codatState.platformName ? codatState.platformName : value;
      setConnectedPlatform(platform + companyName);
      register(name);
      setValue(name, platform);
      dispatch(setCodatState(codatState));
    }
  }, [codatState.platformName, codatState.integration, codatState.statusCode, value]);

  useEffect(() => {
    if (!codatIntegrationLoadInProgress && codatIntegration.length === 0) {
      dispatch(getCodatIntegration());
    }
  }, []);
  useEffect(() => {
    return () => {
      unregister()
    };
  }, [])
  return <div style={{ width: '100%' }}>
    {source === "adf" && connectedPlatform &&
      <div className={styles.connectionPlatform}>
        <div className={styles.connectionBanner}>
            <img className={styles.connectionWarningIcon} src={WARNING_URL} alt="Warning" />
            <div className={styles.connectionText}>
              <div className={styles.connectionTextHeading}>
                Connection Pending: {connectedPlatform}
                </div>
                <div className={styles.connectionTextDescription} data-testid="complete-additional">
                  You’ve successfully connected your accounting data. To finalize the connection, complete the additional details below and submit the form.
                  </div>
              </div>
          </div>
      </div>
    }
    
   {/* TODO: The successful button should be disabled so that it is not clickable
   also the text color should still be theme.palette.text.primary */}
    {source !== "adf" && connectedPlatform &&
      <div>
        <div className={styles.successfulBox}>
          <CheckCircleIcon className={styles.successfulConnection} />
          <span className={styles.connectedItem}> Connected: {connectedPlatform}</span>
        </div>
        <Spacing />
        <input
          type="hidden"
          name={name}
          value={connectedPlatform}
        />
      </div>
    }
    {
      !connectedPlatform && <Button onClick={() => props.handleOpenSyncModal()} variant="outlined" size="large" className={styles.box}>        
        <span className={styles.buttonText}>
          <AddCircleOutlineIcon className={styles.icon}/>
          {codatState.integration && connectedPlatform ? "Add data another source" : "Add data source (Parent Company)"}
        </span>
      </Button>
    }
    {(currentStepperIndex === 5) && <><Spacing />
      <Typography data-testid="disclosure" className={styles.disclosure}>{STATIC_TEXT.codatLink.disclosurePrefix}
        <a
          className={styles.privacyStatementLink}
          href={FCB_PRIVACY_STATEMENT}
          target="_blank"
          rel="noopener noreferrer"
        >
          {STATIC_TEXT.codatLink.privacyStatement}
        </a>
        {STATIC_TEXT.codatLink.disclosureSuffix}
    </Typography></>}
  </div>
}